module.exports = __webpack_public_path__ + "media/images/default_profile0-6c7c67ea66d2a909a84e3d2a7dae189b.jpg";